import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  children: React.ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  children,
  className = "",
  ...props
}: ButtonProps) {
  const baseStyles =
    "font-bold rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

  const variantStyles = {
    primary:
      "bg-[#395839] text-white hover:bg-[#2d4629] hover:scale-105 hover:shadow-lg hover:shadow-[#395839]/25 focus:ring-[#395839] active:bg-[#243620] active:scale-100",
    secondary:
      "bg-white text-black hover:bg-gray-100 focus:ring-gray-400 active:bg-gray-200",
    outline:
      "bg-transparent border-2 border-[#395839] text-[#395839] hover:bg-[#395839]/10 hover:scale-105 focus:ring-[#395839]",
  };

  const sizeStyles = {
    sm: { padding: "0.75rem 2rem", minHeight: "44px", fontSize: "0.875rem" },
    md: { padding: "0.875rem 3rem", minHeight: "48px", fontSize: "1rem" },
    lg: { padding: "1rem 4rem", minHeight: "52px", fontSize: "1.125rem" },
  };

  const widthStyles = fullWidth ? "w-full" : "";

  return (
    <button
      className={`${baseStyles} ${variantStyles[variant]} ${widthStyles} ${className}`}
      style={
        typeof sizeStyles[size] === "object" ? sizeStyles[size] : undefined
      }
      {...props}
    >
      {children}
    </button>
  );
}
